/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { Component } from "react";

// REDUX
import { connect } from "react-redux";

// PACKAGES
import debounce from "lodash.debounce";
import PropTypes from "prop-types";
import { isMobile, isTablet } from "react-device-detect";
import _ from "underscore";

// GRAPHQL
import { useQuery } from "@apollo/client";
import { STORE_MENU_QUERY_V2 } from "../../graphql/product";
import * as currencyActions from "../../redux/actions/currency";
import * as addressActions from "../../redux/actions/address";
import * as elementsActions from "../../redux/actions/elements";
import * as userActions from "../../redux/actions/user";
import { store } from "../../redux/store";
import { defaultCurrency } from "../../shared/constants/currency";
import * as tagmanagerEvents from "../../shared/utilities/tagmanagerEvents";
import { orderMethods, orderTypeIds } from "../../shared/constants/order";
import {
  COOKIE_DEALS,
  COOKIE_MAGIC_BRANDED,
} from "../../shared/constants/product";
import {
  isSampleStore,
  shippingMethods,
  storeIds,
} from "../../shared/constants/store";
import * as orderRepo from "../../shared/repos/graphql/order";
import { OrderEvent } from "../../shared/constants/OrderEvent";
import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";

// COMPONENTS
import CallOut from "../../components/CallOut/CallOut";
import Loader from "../../components/Loader/Loader";
import ProductCard from "../../components/ProductCard/ProductCard";
import ProductModal from "../../components/ProductModal/ProductModal";
import ProductsHeader from "../../components/ProductsHeader/ProductsHeader";
import FullScreenHomepageProductsHeader from "../../components/ProductsHeader/FullScreenHomepageProductsHeader/FullScreenHomepageProductsHeader";
import SideCart from "../../components/SideCart/SideCart";

// STYLES
import "./Braze.css";
import styles from "./Menu.module.css";

// CONSTANTS
import endpoints from "../../shared/constants/endpoints";
import cmsKeys from "../../shared/constants/cms";

// UTILS
import elementConstants from "../../shared/constants/element";
import { marketingEvents } from "../../shared/constants/marketing";
import messages from "../../shared/constants/messages";
import * as brazeRepo from "../../shared/repos/marketing/braze";
import { routeCountryPath } from "../../shared/utilities/common";
import guardOrderChange from "../../shared/utilities/orders";
import {
  addCountryPathToLocation,
  getLocationWithoutCountryPath,
} from "../../shared/utilities/pathes";
import { resolveAmplitudePageName } from "../../shared/utilities/amplitudePageMapping";
import {
  goBackToMain,
  handlePickupStoreSelectionWithDirectLink,
} from "../../shared/utilities/store";
import orderDispatches from "../../shared/utilities/order-dispatches";
import DeliveryPickUpWidget from "../../components/DeliveryPickUpWidget/DeliveryPickUpWidget";
import * as cms from "../../shared/repos/cms/cms";
import Input from "../../components/Input/Input";
import { handleCreateCart } from "../../shared/utilities/cart";
import amplitudeAnalytics from "../../shared/utilities/amplitude";

/*
  NOTE: PLEASE DELETE ALL THESE REFERENCES AND IMGS FOLDER
  WHEN GRAPHQL IS CONNECTED
*/

const shippingBanner = require("./imgs/shipping-banner.png");
const loyaltyBanner = require("./imgs/loyalty-banner.png");

export class Menu extends Component {
  lastTrackedSearchKeyword = '';

  constructor(props) {
    super(props);
    this.state = {
      content: [],
      showModal: false,
      showSideCart: false,
      inputSearchProduct: "",
      showSuggestions: false,
      categoryObjects: [],
      categorizedMenu: {},
      searchProductCount: 0,
    };

    this.menuItemSectionElement = React.createRef();
    this.inputSearchProductRef = React.createRef();
    this.categoryNavigationHandler = null;
    this.initialCategoryNavigationHandled = false;
    this.isInitialCategoryNavigationInProgress = false;
    this.menuSectionObserver = null;
    this.observedSectionIds = new Set();
  }

  componentDidMount() {
    const {
      match,
      userOrderMethod,
      setUserOrderMethod,
      location,
      userAddress,
      userCartId,
      setUserCartId,
      selectedStore,
      setUserAddress,
    } = this.props;
    const storeId = match.params.store_id;
    setTimeout(() => this.handleRouting(), 0);
    if (!Number.isNaN(storeId) && !Number.isNaN(parseInt(storeId, 10))) {
      handlePickupStoreSelectionWithDirectLink(this, storeId);
    }
    this.handleInitialCategoryNavigation();
    const handleScroll = debounce(this.handleMenuScroll, 100);
    window.addEventListener("scroll", handleScroll);
    cms.getContent([cmsKeys.placeholders.enterShippingAddress], this);

    if (location?.pathname?.includes("/shipping")) {
      setUserOrderMethod(orderMethods.shipping);
    }

    if (userAddress && (!userCartId || userCartId.length === 0)) {
      handleCreateCart(
        selectedStore,
        userAddress,
        userOrderMethod,
        setUserCartId,
        setUserAddress,
      ).then(() => this.handleRouting());
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedStore, location, redirectUrl } = this.props;
    if (prevProps.selectedStore !== selectedStore) {
      this.handleRouting();
    }
    if (
      this.getPendingMenuAnchorFromProps(prevProps) !==
        this.getPendingMenuAnchorFromProps({ location, redirectUrl })
    ) {
      this.initialCategoryNavigationHandled = false;
    }
    this.handleInitialCategoryNavigation();
    this.updateGradientForRebrand();
  }

  componentWillUnmount() {
    this.disconnectMenuSectionObserver();
  }

  updateGradientForRebrand = () => {
    if (!isBrandRefreshEnabled()) return;
    const browniesSection = document.getElementById('products_brownies');
    if (browniesSection) {
      // Use absolute document position (offsetTop) so the gradient stays
      // anchored to the brownies section regardless of scroll position.
      // Using getBoundingClientRect().top would shift with the viewport.
      const browniesAbsoluteTop = browniesSection.offsetTop;
      const gradientStart = browniesAbsoluteTop - 180;
      const menuContainer = document.querySelector('[class*="menuContainer"]');
      if (menuContainer) {
        menuContainer.style.background = `linear-gradient(to bottom, #3b0055 0%, #3b0055 ${gradientStart}px, #cfae76 ${gradientStart + 440}px, #cfae76 100%)`;
      }
    }
  }

  /**
   * Handles product menu sub routing based on saved data available
   */
  handleRouting = () => {
    const {
      selectedStore,
      history,
      location,
      selectedCountry,
      isCountrySelectActive,
    } = this.props;
    const storeMenu =
      location.pathname.includes(endpoints.getMenuUrl(selectedStore)) ||
      location.pathname === "/";
    // Emit Braze Event for Store Changed
    if (selectedStore) {
      brazeRepo.logEvent(marketingEvents.STORE_CHANGED, {
        Store_Id: parseInt(selectedStore.id, 10),
      });
      tagmanagerEvents.viewMenu(parseInt(selectedStore.id, 10));
    }

    if (selectedStore && storeMenu && selectedStore.id === storeIds.doughPro) {
      return history.push(
        routeCountryPath(
          addCountryPathToLocation(
            endpoints.doughProPage,
            selectedCountry.path_url,
            isCountrySelectActive,
          ),
        ),
      );
    }
    // if user has selected a store
    if (selectedStore && storeMenu) {
      const {hash} = window.location;
      return history.push(
        routeCountryPath(
          addCountryPathToLocation(
            `${endpoints.getMenuUrl(selectedStore)}${location.search}${hash || ""}`,
            selectedCountry.path_url,
            isCountrySelectActive,
          ),
        ),
      );
    }
    // otherwise return to base home menu
    if (storeMenu) {
      brazeRepo.logEvent(marketingEvents.STORE_CHANGED, {
        Store_Id: storeIds.sampleMenu,
      });
      const {hash} = window.location;
      return history.push(
        routeCountryPath(
          addCountryPathToLocation(
            `${location.pathname}${location.search}${hash || ""}`,
            selectedCountry.path_url,
            isCountrySelectActive,
          ),
        ),
      );
    }
    return null;
  };

  renderBannerLeftChild = (
    header,
    subHeader,
    label1,
    action1,
    label2,
    action2,
  ) => {
    return (
      <div>
        <h1>{header}</h1>
        <p>{subHeader}</p>
        <div>
          {label1 ? (
            <button
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && action1()}
              onClick={action1}
              type="button"
            >
              {label1}
            </button>
          ) : null}
          {label2 ? (
            <button
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && action2()}
              onClick={action2}
              type="button"
            >
              {label2}
            </button>
          ) : null}
        </div>
      </div>
    );
  };

  renderBoxCallOutRightChild = (src, imgClass) => {
    return (
      <div className={imgClass}>
        <img alt="" src={src} />
      </div>
    );
  };

  filterProducts = (products, showOosProducts = false) => {
    if (products.length > 0) {
      const { cakeTopperMobileHide, cakeTopperProductID } = this.props;
      let productLists = products.slice();
      if (productLists.length > 0 && showOosProducts === false) {
        productLists = productLists.filter((product) => product.oos !== 1);
      } else {
        productLists = productLists.sort((a, b) => {
          if (a.oos === 1) {
            return 1;
          }
          if (b.oos === 1) {
            return -1;
          }
          return 0;
        });
      }
      const filterProduct = productLists.filter(
        (product) =>
          cakeTopperMobileHide === "true" &&
          product.id === cakeTopperProductID &&
          isMobile &&
          !isTablet,
      );
      if (filterProduct.length > 0) {
        productLists = productLists.filter(
          (product) => product.id !== filterProduct[0].id,
        );
      }

      return productLists;
    }
    return products;
  };

  handleProductSearchChange = (keyword, searchProductCount = 0) => {
    const normalizedKeyword = String(keyword || "");
    const { inputSearchProduct } = this.state;
    if (inputSearchProduct !== normalizedKeyword) {
      if (!normalizedKeyword.trim()) {
        this.lastTrackedSearchKeyword = "";
      }
      this.setState({
        inputSearchProduct: normalizedKeyword,
        showSuggestions: Boolean(normalizedKeyword.trim()),
        searchProductCount: normalizedKeyword.trim() ? searchProductCount : 0,
      });
    }
  };

  handleProductSearchSelect = (keyword) => {
    const { inputSearchProduct } = this.state;
    if (inputSearchProduct !== keyword) {
      tagmanagerEvents.searchMenu(keyword);
      this.trackSearchMenu(keyword);
      this.setState({ inputSearchProduct: keyword, showSuggestions: false });
    }
  };

  trackSearchMenu = (keyword) => {
    const normalizedKeyword = String(keyword || "").trim();
    if (!normalizedKeyword || this.lastTrackedSearchKeyword === normalizedKeyword) {
      return;
    }
    amplitudeAnalytics.trackSearchMenu({ queryString: normalizedKeyword });
    this.lastTrackedSearchKeyword = normalizedKeyword;
  };

  handleFocusOut = (
    type,
    searchKeyword,
    listingKeywords,
    searchResultProducts,
  ) => {
    this.trackSearchMenu(searchKeyword);
    const { userCartId } = this.props;
    if (searchKeyword && userCartId) {
      tagmanagerEvents.searchMenu(searchKeyword);
      const productIds = searchResultProducts.map((product) =>
        parseInt(product.id, 10),
      );
      orderRepo.orderEvent(OrderEvent.SEARCH_MENU, userCartId, {
        [type]: searchKeyword,
        listingKeywords,
        productIds,
      });
    }
  };

  getUniqueProducts = (allProducts) => {
    return Array.from(
      new Map(allProducts.map((product) => [product.id, product])).values(),
    );
  };

  searchProduct = (productList, limit) => {
    const { inputSearchProduct } = this.state;
    // If there's no search input, return an empty array
    if (!inputSearchProduct) {
      return [];
    }

    // Convert the search input to lowercase for case-insensitive comparison
    const inputSearchProductLower = inputSearchProduct.toLowerCase();

    // Filter the productListFiltered to include only those products that match the search term
    let filteredProducts = productList.filter((product) => {
      const metaTags = Array.isArray(product.metaTags) ? product.metaTags : [];
      // Check if there's a meta tag containing the keyword for each product
      const metaTagMatch = metaTags.some((tag) =>
        tag.title.toLowerCase().includes(inputSearchProductLower),
      );

      // Check if the product title contains the keyword
      const titleMatch = product.title
        .toLowerCase()
        .includes(inputSearchProductLower);

      // Return true if either the meta tag or the title matches the search term
      return metaTagMatch || titleMatch;
    });

    if (limit && limit > 0) {
      filteredProducts = filteredProducts.slice(0, limit);
    }

    return filteredProducts;
  };

  getUniqueProductKeywords = (productList) => {
    const keywords = new Set();

    productList.forEach((product) => {
      // Add the product title to the set
      if (product.title) {
        keywords.add(product.title.toLowerCase());
      }

      // Add the meta tags to the set
      if (product.metaTags) {
        product.metaTags.forEach((tag) => {
          if (tag.title) {
            keywords.add(tag.title.toLowerCase());
          }
        });
      }
    });

    // Convert the set back to an array
    return Array.from(keywords);
  };

  /**
   * Renders product section UI
   * @param {String} type
   * @param {String} header
   * @param {Object} productsContainer
   * @param {String} anchor - necessary for scrollTo functionality on filter component
   * NOTE: DO NOT ADD DUPLICATES & ONLY SET ON FIRST TYPE OF
   */
  renderProductSection = (
    type,
    header,
    productsContainer,
    anchor,
    categoryDescription = null,
    parentCategory = null,
    showOssProducts = false,
    parentHeader = null,
  ) => {
    if (!productsContainer) {
      return undefined;
    }
    const hasChildren = !_.isEmpty(productsContainer.children);
    const children = [];

    // Determine heading level based on parent category
    const isSubCategory =
      parentCategory && parentCategory.toLowerCase() === "cookies";
    const headingLevel = isSubCategory ? "h3" : "h2";

    if (hasChildren) {
      Object.keys(productsContainer.children).forEach((child) => {
        const childItem = productsContainer.children[child];
        if (showOssProducts === false) {
          const childNonOosProducts = childItem.products.filter(
            (product) => product.oos !== 1,
          );
          if (
            childNonOosProducts.length === 0 &&
            _.isEmpty(childItem.children)
          ) {
            return;
          }
        }
        children.push(
          this.renderProductSection(
            type,
            child,
            productsContainer.children[child],
            null,
            productsContainer.children[child].description,
            isBrandRefreshEnabled() ? null : header,
            showOssProducts,
            header,
          ),
        );
      });
    }

    const { products } = productsContainer;

    if (hasChildren) {
      const sectionId = anchor || `products_${productsContainer.slug}`;
      const shouldHideTitle = isBrandRefreshEnabled() && header?.toLowerCase() === "cookies";
      const headerLower = header?.toLowerCase();
      const needsDarkHeading = isBrandRefreshEnabled()
        && headerLower
        && this.isCategoryAfterBrownies(headerLower);
      return (
        <div id={sectionId} style={needsDarkHeading ? { '--menu-section-heading-color': '#3B0055' } : undefined}>
          <div className={shouldHideTitle ? styles.menuSectionTitleParent : ""}>
            <div className={`w-full text-center ${isBrandRefreshEnabled() ? '' : 'mb-6'}`}>
              {React.createElement(
                headingLevel,
                {
                  className: `${styles.menuSectionTitle} ${shouldHideTitle ? styles.menuSectionTitleParent : ""}`,
                },
                header?.toUpperCase(),
              )}
            </div>
          </div>
          {!isBrandRefreshEnabled() && categoryDescription && (
            <p className="md:text-center h-full text-darkElevationPrimary dark:text-darkElevationSecondary text-lg leading-4 mt-3">
              {categoryDescription}
            </p>
          )}
          <div className={`${styles.productsSection}`}>
            {_.flatten(children).map((child) => {
              return child;
            })}
          </div>
        </div>
      );
    }

    if (products) {
      const {
        userAddress,
        selectedStore,
        isCaloriesActive,
        currency,
        location,
        selectedCountry,
      } = this.props;
      const isShipping = !selectedStore
        ? false
        : selectedStore.id === storeIds.shipping;
      const { inputSearchProduct, searchProductCount } = this.state;
      const amplitudeProductCategory = parentCategory || header || '';
      const pathForAmplitude = getLocationWithoutCountryPath(
        location?.pathname || '',
        selectedCountry?.['path_url'] ?? '',
      );
      const amplitudeCardPageName = resolveAmplitudePageName(pathForAmplitude);
      // Filter products to hide custom cake topper in mobile screens
      const productList = this.filterProducts(products, showOssProducts);

      parentCategory = parentCategory ? parentCategory.toLowerCase() : null; // eslint-disable-line

      if (!hasChildren && (parentCategory === "ice cream" || parentCategory === "packs")) {
        header = null; // eslint-disable-line
      }

      if (header !== COOKIE_MAGIC_BRANDED) {
        // eslint-disable-next-line no-param-reassign
        header = header ? header.toLowerCase() : null; // eslint-disable-line
      }

      if (isBrandRefreshEnabled() && header && parentHeader && header.toLowerCase().trim() === parentHeader.toLowerCase().trim()) {
        header = null; // eslint-disable-line
      }
      const headerLowerForDark = header?.toLowerCase();
      const needsDarkHeading = isBrandRefreshEnabled()
        && headerLowerForDark
        && this.isCategoryAfterBrownies(headerLowerForDark);
      return (
        <div
          id={anchor || `products_${productsContainer.slug}`}
          className={`
            ${styles.productsSection}
            flex flex-col md:gap-16 ${isBrandRefreshEnabled() ? '' : 'text-dark dark:text-white'}`}
          style={needsDarkHeading ? { '--menu-section-heading-color': '#3B0055' } : undefined}
        >
          <div
            className={`${
              isBrandRefreshEnabled() ? "py-10 md:py-0 md:mt-6 text-center" : (!header ? "mb-12 md:mb-0" : "py-10 md:py-0 md:mt-6 text-center")
            } ${styles.menuSectionHeadingWrapper}`}
          >
            {(!isBrandRefreshEnabled() || header) && (header !== "for you" ||
            (inputSearchProduct && searchProductCount > 0)) ? (
              <>
                <div className={`w-full text-center ${isBrandRefreshEnabled() ? '' : 'mb-6'} ${styles.menuSectionHeadingInner}`}>
                  {React.createElement(
                    headingLevel,
                    {
                      className: styles.menuSectionTitle,
                    },
                    header?.toUpperCase(),
                  )}
                </div>
                {!isBrandRefreshEnabled() && categoryDescription && (
                  <p className="md:text-center text-darkElevationPrimary dark:text-darkElevationSecondary text-lg leading-4 mt-3">
                    {categoryDescription}
                  </p>
                )}
              </>
            ) : null}
          </div>

          <div className={styles.productsContainerWrapper}>
            <div
              data-ddog-id="menu_product_cards"
              className={`
              ${styles.productsContainer}`}
            >
              {productList.map((product, index) => {
                const { title } = product;
                const price = userAddress ? product.price : null;
                const upsellFeatured =
                  anchor === COOKIE_DEALS ? product.upsellFeatured : false;
                const priceFormatted =
                  price && (isShipping || !isSampleStore(selectedStore?.id))
                    ? price.toFixed(2)
                    : null;
                const strikePrice =
                  price && product.strike_price
                    ? product.strike_price.toFixed(2)
                    : null;
                const charMax = 200;
                const description =
                  product.description.length > charMax
                    ? `${product.description.substring(0, charMax)}...`
                    : product.description;

                const isEven = (index + 1) % 2 === 0;
                const isBox = product.hasAssortments;
                const isCustom = product.options && product.options.length > 0;
                const calories =
                  isCaloriesActive && product.calories != null
                    ? ` ${product.calories} kCal`
                    : "";
                return (
                  <div
                    data-ddog-id="menu_item_product_card"
                    key={`dkey-${product.id}`}
                    className={`${
                      styles[`${type}Product`]
                    } w-full h-auto mx-auto`}
                  >
                    <ProductCard
                      key={`key-${product.id}`}
                      title={title}
                      id={product.id}
                      productSlug={product.productSlug}
                      isBox={isBox}
                      isCustom={isCustom}
                      description={description}
                      price={priceFormatted}
                      strikePrice={strikePrice}
                      type={type}
                      alternate={isEven}
                      primaryImage={product.productImageSmall}
                      secondaryImage={product.accentImage}
                      categories={product.categories}
                      upsellFeatured={upsellFeatured}
                      calories={calories}
                      currency={currency}
                      oos={product.oos}
                      discountPercent={product.discountPercent}
                      amplitudeProductCardContext={{
                        ...(amplitudeCardPageName ? { pageName: amplitudeCardPageName } : {}),
                        productCategory: amplitudeProductCategory || product.categories?.[0]?.title || '',
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div className={`md:mb-16 ${styles.productsSectionSpacer}`} />
        </div>
      );
    }
    return undefined;
  };

  getCategorizedMenu = (menu) => {
    const mappedMenu = menu.map((item) => {
      const productCategory = item.category;
      return { ...item, productCategory };
    });
    const categorizedMenu = {};
    function populateCategory(category, productsContainer) {
      const { products, children } = category;
      const childGroupedList = _.groupBy(children, (item) => item.category);
      const childObj = {};
      _.each(childGroupedList, (item) => {
        item.forEach((product) => {
          childObj[product.category] = {
            slug: product.slug,
            description: product.description,
            products: product.products,
          };
        });
      });

      // eslint-disable-next-line no-param-reassign
      productsContainer[category.category] = {
        products,
        slug: category.slug,
        children: childObj,
      };
    }
    mappedMenu.forEach((category) => {
      populateCategory(category, categorizedMenu);
    });
    return categorizedMenu;
  };

  handleStoreMenu = async (menu, categoriesList) => {
    const {
      setSelectedStore,
      setUserCartId,
      userCartId,
      setUserOrderMethod,
      location,
      selectedStore,
      setMenuCategories,
      setProducts,
      modalObject,
      isShippingActive,
    } = this.props;

    setProducts(menu);

    const categorizedMenu = this.getCategorizedMenu(menu);
    const sortedCategories = [];

    const categoryObjects = [];
    menu.forEach((item) => {
      return categoryObjects.push({
        key: item.category,
        cardSize: "medium",
        navTitle: item.category,
        menuTitle: item.category,
        categoryDescription: item.description,
        anchor: item.slug,
        productLength: item.products.length,
      });
    });

    const obj = {};
    for (let i = 0; i < categoryObjects.length; i += 1) {
      obj[categoryObjects[i].anchor] = categoryObjects[i];
    }

    for (let i = 0; i < categoriesList.length; i += 1) {
      if (
        obj[categoriesList[i].slug] &&
        obj[categoriesList[i].slug].productLength > 0
      ) {
        sortedCategories.push(obj[categoriesList[i].slug]);
      }
    }

    // Walk the menu hierarchy in display order (top-level first, then each
    // category's children in order). Every category at or after "brownies"
    // in this traversal needs a dark purple heading on the tan/beige
    // background. This works for any store configuration because it relies
    // only on the data returned by the API, not on hardcoded category names.
    const darkHeadingHeaders = new Set();
    let foundBrownies = false;
    const walkMenu = (items) => {
      if (!Array.isArray(items)) return;
      items.forEach((item) => {
        if (!item) return;
        if (item.category) {
          const lower = item.category.toLowerCase();
          if (lower === "brownies") {
            foundBrownies = true;
          }
          if (foundBrownies) {
            darkHeadingHeaders.add(lower);
          }
        }
        if (Array.isArray(item.children) && item.children.length > 0) {
          walkMenu(item.children);
        }
      });
    };
    walkMenu(menu);
    this.darkHeadingHeaders = darkHeadingHeaders;

    this.setState(
      {
        categorizedMenu,
        categoryObjects: sortedCategories,
      },
      this.handleInitialCategoryNavigation,
    );
    setMenuCategories(sortedCategories);
    if (location.pathname.includes("/shipping") && isShippingActive) {
      const orderData = {
        orderTypeId: orderTypeIds.shipping,
        storeId: storeIds.shipping,
        shippingMethod: shippingMethods.shipping,
      };

      if (
        selectedStore &&
        parseInt(selectedStore.id, 10) !== parseInt(storeIds.shipping, 10) &&
        !modalObject
      ) {
        guardOrderChange(true, () => {
          this.shippingStoreChangeModalOkayAction();
        });
      } else if (!userCartId) {
        setSelectedStore({ id: storeIds.shipping });
        setUserOrderMethod(orderMethods.shipping);
        const response = await orderRepo.createCart(orderData);
        const { createCart } = response.data;
        setUserCartId(createCart.code);
      }
    }

    return null;
  };

  shippingStoreChangeModalOkayAction = () => {
    const { setSelectedStore, setUserOrderMethod } = this.props;

    setSelectedStore({ id: storeIds.shipping });
    setUserOrderMethod(orderMethods.shipping);
  };

  evaluateQuery = () => {
    const {
      location,
      selectedStore,
      setCurrency,
      isShowOosProducts,
    } = this.props;

    let storeId = selectedStore ? selectedStore.id : storeIds.sampleMenu;

    if (location.pathname.includes("/shipping")) {
      storeId = storeIds.shipping;
    }

    return useQuery(STORE_MENU_QUERY_V2, {
      fetchPolicy: "no-cache",
      variables: { id: storeId, isShowOosProducts },
      onCompleted: async (data) => {
        this.handleStoreMenu(data.store.menuV2, data.store.categoriesList);
        setCurrency(data.store.currency);
      },
    });
  };

  getBanners = () => {
    const { history, location, selectedStore, isShippingActive } = this.props;
    const shippingCall = true;
    let shippingBannerData;

    const isCookieLabStore =
      parseInt(selectedStore?.id, 10) === storeIds.cookieLab;

    if (location.pathname.includes(endpoints.shippingPage)) {
      shippingBannerData = {
        shippingBannerHeader: messages.shippingMenu.shippingBannerHeader,
        shippingBannerSubHeader: messages.shippingMenu.shippingBannerSubHeader,
        shippingBannerLabel1: messages.shippingMenu.shippingBannerLabel1,
        shippingBannerAction: () => {
          window.location.href = endpoints.salesSite;
        },
      };
    } else {
      shippingBannerData = {
        shippingBannerHeader: messages.mainMenu.shippingBannerHeader,
        shippingBannerSubHeader: messages.mainMenu.shippingBannerSubHeader,
        shippingBannerLabel1: messages.mainMenu.shippingBannerLabel1,
        shippingBannerAction: () => {
          history.push(routeCountryPath(endpoints.shippingPage));
        },
      };
    }

    return [
      <div className={`${styles.bannerWrapper} mt-[180px]`}>
        <CallOut
          leftChild={this.renderBannerLeftChild(
            "Make it a box",
            "Mix and match with your faves for a combo deal.",
            "Customize my box",
            () => history.push(routeCountryPath("/products/box/7")),
            "Pick for me",
            () => history.push(routeCountryPath("/products/box/7/assortment")),
          )}
          rightChild={this.renderBoxCallOutRightChild()}
          isCookieLab={isCookieLabStore}
        />
      </div>,
      <div className={`${styles.bannerWrapper} mt-[180px]`}>
        <CallOut
          leftChild={this.renderBannerLeftChild(
            "Start earning dough",
            "Join our cookie dough loyalty program to earn points towards free cookies today.",
            "Join now",
            () => history.push(routeCountryPath("/create-account")),
            "Learn more",
            () => history.push(routeCountryPath("/loyalty")),
          )}
          rightChild={this.renderBoxCallOutRightChild(
            loyaltyBanner,
            styles.boxBannerAssetWrapper,
          )}
          isCookieLab={isCookieLabStore}
        />
      </div>,
      isShippingActive && (
        <div className={`${styles.bannerWrapper} mt-[100px]`}>
          <CallOut
            leftChild={this.renderBannerLeftChild(
              shippingBannerData.shippingBannerHeader,
              shippingBannerData.shippingBannerSubHeader,
              shippingBannerData.shippingBannerLabel1,
              shippingBannerData.shippingBannerAction,
              null,
              null,
            )}
            rightChild={this.renderBoxCallOutRightChild(
              shippingBanner,
              styles.boxShippingBannerAssetWrapper,
            )}
            isShipping={shippingCall}
            isCookieLab={isCookieLabStore}
          />
        </div>
      ),
    ];
  };

  observerIntersection = (entries) => {
    const { setProductCategory } = this.props;
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = entry.target.getAttribute("id");
        setProductCategory(id);

        if (!this.isInitialCategoryNavigationInProgress) {
          const categorySelector = document.getElementById(
            `menuCategorySelector-${id}`,
          );

          if (categorySelector) {
            categorySelector.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "center",
            });
          }
        }
      }
    });
  };

  handleMenuScroll = () => {
    // Create the observer once and reuse it. The rootMargin offsets the
    // observation area to account for the sticky category filter bar at the
    // top of the viewport (especially important on mobile where the sticky
    // bar takes more relative space). A section is considered "active" when
    // it enters the upper portion of the visible viewport, below the sticky
    // bar. This prevents the wrong category from being highlighted when the
    // top of one section peeks above the sticky bar.
    if (!this.menuSectionObserver) {
      this.menuSectionObserver = new IntersectionObserver(
        this.observerIntersection,
        {
          threshold: 0,
          rootMargin: "-56px 0px -70% 0px",
        },
      );
    }

    const { categoryObjects } = this.state;
    categoryObjects.forEach((item) => {
      const { anchor } = item;

      if (this.observedSectionIds.has(anchor)) {
        return;
      }
      const section = document.getElementById(anchor);
      if (section) {
        this.menuSectionObserver.observe(section);
        this.observedSectionIds.add(anchor);
      }
    });
  };

  disconnectMenuSectionObserver = () => {
    if (this.menuSectionObserver) {
      this.menuSectionObserver.disconnect();
      this.menuSectionObserver = null;
    }
    this.observedSectionIds = new Set();
  };

  normalizeMenuAnchor = (value) => {
    if (!value || typeof value !== "string") {
      return null;
    }

    const normalizedAnchor = value.includes("#")
      ? value.split("#").pop()
      : value.replace(/^#/, "");

    return normalizedAnchor || null;
  };

  getPendingMenuAnchor = () => {
    const { location, redirectUrl } = this.props;
    return this.getPendingMenuAnchorFromProps({ location, redirectUrl });
  };

  getPendingMenuAnchorFromProps = (props) => {
    return (
      this.normalizeMenuAnchor(props?.redirectUrl) ||
      this.normalizeMenuAnchor(props?.location?.hash)
    );
  };

  clearPendingMenuAnchor = () => {
    const { redirectUrl, setRedirectUrl } = this.props;

    if (redirectUrl) {
      setRedirectUrl("");
    }
  };

  registerCategoryNavigationHandler = (handler) => {
    this.categoryNavigationHandler = handler;
    this.handleInitialCategoryNavigation();
  };

  /**
   * Returns true when the given header (lowercased) sits at or after the
   * "brownies" category in the categories list. Used to flip section
   * headings to dark purple on the tan/beige background.
   */
  isCategoryAfterBrownies = (headerLower) => {
    if (!headerLower) return false;
    const darkHeaders = this.darkHeadingHeaders;
    return Boolean(darkHeaders && darkHeaders.has(headerLower));
  };

  handleDirectLinkScroll = (anchorOverride = null) => {
    const { setProductCategory } = this.props;
    const anchor = anchorOverride || this.getPendingMenuAnchor();

    if (!anchor) {
      return false;
    }

    const categorySelector = document.getElementById(anchor);

    if (!categorySelector) {
      return false;
    }

    setProductCategory(anchor);
    const yPos = categorySelector.offsetTop - elementConstants.manualDeltaScroll;
    window.scrollTo({ top: yPos, behavior: "instant" });
    return true;
  };

  handleInitialCategoryNavigation = () => {
    const anchor = this.getPendingMenuAnchor();

    if (!anchor || this.initialCategoryNavigationHandled) {
      return false;
    }

    const wasHandled = this.categoryNavigationHandler
      ? this.categoryNavigationHandler(anchor, { behavior: "smooth" })
      : this.handleDirectLinkScroll(anchor);

    if (wasHandled) {
      this.isInitialCategoryNavigationInProgress = true;
      this.initialCategoryNavigationHandled = true;
      this.clearPendingMenuAnchor();
      window.setTimeout(() => {
        this.isInitialCategoryNavigationInProgress = false;
      }, 600);
    }

    return wasHandled;
  };

  handleCloseShippingWidget = () => {
    const { history, userCart } = this.props;
    const homePath = routeCountryPath(endpoints.homePage);

    if (userCart.length > 0) {
      goBackToMain(history.push, homePath);
    } else {
      orderDispatches(store, userActions, elementsActions);
      history.push(homePath);
    }
  };

  showDeliveryPickupWidgetModal = () => {
    const { content } = this.state;
    return (
      <div className={`${styles.menuContainer} w-full ${isBrandRefreshEnabled() ? 'pb-16' : 'mb-16'}`}>
        <div className="lg:max-w-screen-desktop  mx-auto pt-9">
          <DeliveryPickUpWidget
            isVisible
            addressType="shipping"
            cmsContent={content}
            onClose={this.handleCloseShippingWidget}
            analyticsPageSection="Below Hero"
          />
        </div>
      </div>
    );
  };

  menuContainer = () => {
    const {
      showModal,
      showSideCart,
      categorizedMenu,
      categoryObjects,
      inputSearchProduct,
      showSuggestions,
    } = this.state;
    const {
      location,
      contentCardData,
      contentCardHandleClick,
      setHeroContentCardData,
      userAddress,
      isShippingActive,
      isContentCardFullWidth,
      useFullscreenCarousel,
    } = this.props;
    const storeMenu =
      location.pathname.includes("/menu") ||
      location.pathname.includes("/goto/store") ||
      location.pathname === "/" ||
      new RegExp(`^[/][a-z]{2}[/]?$`).test(location.pathname);
    const isShippingMenu = location.pathname.includes(endpoints.shippingPage);
    const showShippingAddressWidgetCondition =
      isShippingActive &&
      isShippingMenu &&
      !storeMenu &&
      !userAddress &&
      !userAddress?.address1;

    if (showShippingAddressWidgetCondition) {
      return this.showDeliveryPickupWidgetModal();
    }
    const { loading } = this.evaluateQuery();

    let firstBoxProduct = null;

    if (!loading) {
      setTimeout(() => {
        if (contentCardData) {
          contentCardHandleClick(contentCardData);
          setHeroContentCardData({
            contentCardHandleClick: null,
            contentCardData: null,
          });
        }
      }, 100);
    }
    const allProducts = []; // Initialize an empty array to hold all products

    _.each(categorizedMenu, (menuItems) => {
      allProducts.push(...menuItems.products);
      menuItems.products.forEach((item) => {
        if (item.featured) {
          firstBoxProduct = item.id;

          return false;
        }
        return true;
      });
    });

    let allProductsCategory = {};
    let searchProducts = [];
    const searchLimit = isMobile ? 5 : null;
    const allUniqueProducts = this.filterProducts(
      this.getUniqueProducts(allProducts),
      true,
    );
    let keywords = [];
    if (inputSearchProduct) {
      searchProducts = this.searchProduct(allUniqueProducts, searchLimit);
      keywords = this.getUniqueProductKeywords(searchProducts);
      allProductsCategory = {
        key: "search",
        cardSize: "medium",
        navTitle: "search",
        menuTitle: "",
        categoryDescription: "",
        anchor: "",
        productLength: searchProducts.length,
        products: searchProducts,
        slug: "search",
      };
      if (!showSuggestions) {
        this.handleFocusOut(
          "selectedKeyword",
          inputSearchProduct,
          [],
          searchProducts,
        );
      }
    }

    // const banners = this.getBanners();

    return (
      <div
        className={`${styles.menuContainer} w-full ${isBrandRefreshEnabled() ? 'pb-16' : 'mb-16'}  mx-auto ${
          !isContentCardFullWidth ? "lg:max-w-screen-desktop pt-9" : ""
        }`}
      >
        {showModal && storeMenu ? (
          <ProductModal exit={this.toggleModal} />
        ) : null}
        {showSideCart ? (
          <SideCart toggleSideCart={this.toggleSideCart} />
        ) : null}

        {storeMenu || isShippingMenu ? (
          useFullscreenCarousel ? (
            <FullScreenHomepageProductsHeader
              firstBoxProduct={firstBoxProduct}
              registerCategoryNavigationHandler={
                this.registerCategoryNavigationHandler
              }
            />
          ) : (
            <ProductsHeader
              firstBoxProduct={firstBoxProduct}
              registerCategoryNavigationHandler={
                this.registerCategoryNavigationHandler
              }
            />
          )
        ) : null}

        {!loading ? (
          <div>
            <div
              className={[
                isBrandRefreshEnabled() ? "" : (!showSuggestions && keywords.length > 0 ? "mb-12 md:mb-0" : ""),
                "flex flex-col justify-center items-center lg:px-0 px-4",
              ].join(" ")}
            >
              <div className={`${styles.searchDivWidth} ${styles.menuSearchWrapper} relative`}>
                {/* Live region for search results count announcement */}
                <div
                  id="search-results-status"
                  role="alert"
                  aria-live="polite"
                  aria-atomic="true"
                  className="sr-only"
                >
                  {inputSearchProduct && keywords.length > 0 && (
                    <span>
                      {keywords.length}
                      {" "}
                      {keywords.length === 1 ? "result" : "results"}
                      {' '}
 found
                    </span>
                  )}
                </div>
                {isBrandRefreshEnabled() ? (
                  <div className={styles.menuSearch}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      className={styles.menuSearchIcon}
                    >
                      <path d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z" stroke="#461D58" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M16.4438 16.4438L21.0001 21.0001" stroke="#461D58" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <Input
                      inputId="menu-search-input"
                      handleInput={(e) =>
                        this.handleProductSearchChange(
                          e?.target?.value,
                          searchProducts.length,
                        )}
                      placeholder="Search menu"
                      value={inputSearchProduct}
                      handleSubmit={() => this.handleProductSearchChange()}
                      ref={this.inputSearchProductRef}
                      customInputContainerStyles={styles.menuSearchInput}
                      handleOnBlur={(e) =>
                        this.handleFocusOut(
                          "searchedKeyword",
                          e?.target?.value,
                          keywords,
                          searchProducts,
                        )}
                      ariaExpanded={showSuggestions && keywords.length > 0}
                      ariaDescribedBy="search-results-status"
                      autoComplete="off"
                      ariaControls={
                        showSuggestions && keywords.length > 0
                          ? "search-suggestions"
                          : undefined
                      }
                    />
                  </div>
                ) : (
                  <Input
                    inputId="menu-search-input"
                    handleInput={(e) =>
                      this.handleProductSearchChange(
                        e?.target?.value,
                        searchProducts.length,
                      )}
                    placeholder="Search Menu"
                    value={inputSearchProduct}
                    handleSubmit={() => this.handleProductSearchChange()}
                    ref={this.inputSearchProductRef}
                    customInputContainerStyles={styles.menuSearch}
                    handleOnBlur={(e) =>
                      this.handleFocusOut(
                        "searchedKeyword",
                        e?.target?.value,
                        keywords,
                        searchProducts,
                      )}
                    ariaExpanded={showSuggestions && keywords.length > 0}
                    ariaDescribedBy="search-results-status"
                    autoComplete="off"
                    ariaControls={
                      showSuggestions && keywords.length > 0
                        ? "search-suggestions"
                        : undefined
                    }
                  />
                )}
                {inputSearchProduct ? (
                  <button
                    type="button"
                    onClick={() => this.handleProductSearchChange()}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        this.handleProductSearchChange();
                      }
                    }}
                    aria-label="Clear search"
                    className={`${styles.closeIcon} absolute cursor-pointer text-dark dark:text-light bg-transparent border-none p-0 h-6 w-6 mt-[-5px]`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                ) : null}
                {inputSearchProduct && keywords.length === 0 && (
                  <div
                    className={styles.errorContainer}
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                  >
                    <p>No product match</p>
                  </div>
                )}
                {showSuggestions && keywords.length > 0 && (
                <div
                  id="search-suggestions"
                  role="listbox"
                  aria-label="Search suggestions"
                  className={`${styles.searchDivWidth} font-montserratMedium text-dark dark:text-white ${isBrandRefreshEnabled() ? styles.searchSuggestionsFloating : ''}
                border-[1px]
                border-borderLight dark:border-none bg-white dark:bg-darkDry
                overflow-y-scroll max-h-[212px] ${isBrandRefreshEnabled() ? '' : 'mb-12 md:mb-0'}`}
                >
                  {keywords.map((suggestion, index) => (
                    <div
                      key={suggestion}
                      role="option"
                      id={`suggestion-${index}`}
                      aria-selected="false"
                      onClick={() => this.handleProductSearchSelect(suggestion)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.handleProductSearchSelect(suggestion);
                        }
                      }}
                      tabIndex={0}
                      className="cursor-pointer p-2 hover:bg-light dark:hover:bg-darkDry"
                    >
                      {suggestion}
                    </div>
                  ))}
                </div>
              )}
              </div>
            </div>
            <div className={`${styles.menuDetailsContainer} lg:px-0 px-4${isBrandRefreshEnabled() ? ' mb-16' : ''}`}>
              {inputSearchProduct && searchProducts.length > 0
                ? this.renderProductSection(
                    allProductsCategory.cardSize,
                    allProductsCategory.menuTitle,
                    allProductsCategory,
                    allProductsCategory.anchor,
                    allProductsCategory.categoryDescription,
                    null,
                    true,
                  )
                : []}
              {categoryObjects
                ? categoryObjects.map((co) => {
                    return [
                      this.renderProductSection(
                        co.cardSize,
                        co.menuTitle,
                        categorizedMenu[co.key],
                        co.anchor,
                        co.categoryDescription,
                        null,
                        false,
                      ),
                      null,
                    ];
                  })
                : null}
            </div>
          </div>
        ) : (
          <div className={styles.loaderWrapper}>
            <Loader />
          </div>
        )}
      </div>
    );
  };

  render() {
    return <this.menuContainer />;
  }
}

Menu.propTypes = {
  cakeTopperMobileHide: PropTypes.string,
  cakeTopperProductID: PropTypes.string,
  isShippingActive: PropTypes.bool,
  isCaloriesActive: PropTypes.bool,
  isShowOosProducts: PropTypes.bool,
  currency: PropTypes.objectOf(PropTypes.string),
  isContentCardFullWidth: PropTypes.bool,
  useFullscreenCarousel: PropTypes.bool,
};

Menu.defaultProps = {
  cakeTopperMobileHide:
    window.environment.REACT_APP_CUSTOM_CAKE_TOPPER_HIDE_MOBILE,
  cakeTopperProductID:
    window.environment.REACT_APP_CUSTOM_CAKE_TOPPER_PRODUCT_ID,
  isShippingActive: true,
  isCaloriesActive: false,
  isShowOosProducts: false,
  currency: defaultCurrency,
  isContentCardFullWidth: false,
  useFullscreenCarousel: isBrandRefreshEnabled(),
};

export const mapStateToProps = (state) => {
  const {
    userCartId,
    selectedStore,
    userOrderMethod,
    userAddress,
    userCart,
    userToken,
  } = state.user;

  const {
    modalObject,
    contentCardHandleClick,
    contentCardData,
    isContentCardFullWidth
  } = state.elements;
  const { isShippingActive } = state.shipping;
  const { isCaloriesActive, isShowOosProducts } = state.product;
  const { currency } = state.currency;
  const { selectedCountry, isCountrySelectActive } = state.country;

  return {
    userCartId,
    selectedStore,
    userOrderMethod,
    userAddress,
    modalObject,
    userCart,
    isShippingActive,
    isCaloriesActive,
    isShowOosProducts,
    currency,
    selectedCountry,
    isCountrySelectActive,
    userToken,
    contentCardHandleClick,
    contentCardData,
    redirectUrl: state.address.redirectUrl,
    isContentCardFullWidth
  };
};

export const mapDispatchToProps = (dispatch) => ({
  setMenuCategories: (value) =>
    dispatch(elementsActions.setMenuCategories(value)),
  setProducts: (value) => dispatch(elementsActions.setProducts(value)),
  setProductCategory: (value) =>
    dispatch(elementsActions.setProductCategory(value)),
  setUserOrderMethod: (value) =>
    dispatch(userActions.setUserOrderMethod(value)),
  setUserCartId: (value) => dispatch(userActions.setUserCartId(value)),
  setSelectedStore: (value) => dispatch(userActions.setSelectedStore(value)),
  setModalObject: (value) => dispatch(elementsActions.setModalObject(value)),
  setCurrency: (value) => dispatch(currencyActions.setCurrency(value)),
  setHeroContentCardData: () =>
    dispatch(elementsActions.setHeroContentCardData()),
  setRedirectUrl: (value) => dispatch(addressActions.setRedirectUrl(value)),
  setUserAddress: (value) => dispatch(userActions.setUserAddress(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
